export const checkLinkForRegistration = (link: string | undefined) => link?.includes('rejestracja');
